// PORTED FROM VUE-UI + ADAPTED TO MAISON

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AIconNamePropertyMixin from '@/mixins/AIconNamePropertyMixin';
import AHasNestedBindingsMixin from '@/mixins/AHasNestedBindingsMixin';

@Component<AAbstractInput>({})
export default class AAbstractInput extends mixins(Vue, AIconNamePropertyMixin, AHasNestedBindingsMixin) {
  protected internalValue: any = (this.$attrs.value !== undefined) && (this.$attrs.value !== null) ? this.$attrs.value : null;

  /**
   * autocomplete lets web developers specify what if any permission the user agent has to provide automated assistance in filling out form field values
   */
  @Prop({ default: true }) protected autocomplete!: boolean;


  public created(): void {
    this.guardInvalidIconPropUse();
  }

  protected get internalLabel(): string | undefined {
    if (typeof this.$attrs.label === 'boolean' && ! this.$attrs.label) {
      return undefined;
    }

    return this.$attrs.label || this.$attrs.placeholder || '';
  }

  @Watch('internalValue')
  public onChangedInternalValue(newValue: any, oldValue: any): void {
    if (oldValue === newValue) return;
    this.$emit('input', newValue);
  }

  @Watch('$attrs.value')
  public onChangedValue(newValue: any, oldValue: any): void {
    if (oldValue === newValue) return;
    this.internalValue = newValue;
  }
}
